const ITEM_COLLECTION_TYPE = {
	marketplaceCollection: 'MARKETPLACE_COLLECTION',
	marketplaceMain: 'MARKETPLACE_MAIN',
};

export default ITEM_COLLECTION_TYPE;